import { Link } from '@/components/Link';
import { Text } from '@/components/Text';
import { useModal } from '@/hooks/useModal';
import { type AdType } from '@/resource/ad';
import { routeToPath } from '@/util/routeToPath';
import { useRouter } from 'next/router';
import { useRef } from 'react';

type Props = {
  confirm?: boolean;
  adType: AdType;
};

export function CancelLink({ confirm = false, adType }: Props) {
  const modal = useModal();
  const router = useRouter();
  const ref = useRef<HTMLAnchorElement>(null);
  const route = { type: `market_${adType}s` } as const;
  const label = adType === 'offer' ? 'aanbod' : 'vraag';

  function cancel() {
    modal.open(
      {
        type: 'confirm',
        props: {
          title: `Weet je zeker dat je wil stoppen met het plaatsen van een ${label}?`,
          onCancel() {
            modal.close();
          },
          onConfirm() {
            modal.close();
            router.push(routeToPath(route));
          },
        },
      },
      () => {
        ref.current?.focus();
      }
    );
  }

  return (
    <Text align="center">
      <Link
        to={route}
        ref={ref}
        underline
        onClick={
          confirm
            ? (e) => {
                e.preventDefault();
                cancel();
              }
            : undefined
        }
      >
        <small>Annuleren</small>
      </Link>
    </Text>
  );
}
